import { render } from "./AreasMenu.vue?vue&type=template&id=5277d178&scoped=true"
import script from "./AreasMenu.vue?vue&type=script&lang=js"
export * from "./AreasMenu.vue?vue&type=script&lang=js"

import "./AreasMenu.vue?vue&type=style&index=0&id=5277d178&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist-eni-for-2022-hub-e-longform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5277d178"]])

export default __exports__